import React from 'react';
import {Table} from 'reactstrap';
import SchedulerRow from './SchedulerRow';

const SchedulerWidget = ({node, onUpdate, values}) => (
    <>
        <h4>Scheduler</h4>
        <div className="table-responsive">
            <Table size="sm">
                <tbody>
                    {node.properties.map((p) => (
                        <SchedulerRow key={p.id} onUpdate={onUpdate}
                            node={node} property={p} data={values[`${node.id}/${p.id}`]} />
                    ))}
                </tbody>
            </Table>
        </div>
    </>
);

export default SchedulerWidget;
